module.exports = __webpack_public_path__ + "static/media/Mi_casa.e45f91d6.png";